import Vue from 'vue';
import moment from 'moment';

declare var numeral: any;

numeral.language('pt-br');
Vue.filter('formatNumber', (value : any) => numeral(value).format('0,0.00'));
Vue.filter('formatTax', (value : any) => numeral(value).format('0,0.0000'));
Vue.filter('formatDate', (value : any) => moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY'));
